(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-2cv"]) return;
  try {
    
  // "Copy link" puts the post's address on the clipboard and shows a tick
  // for a couple of seconds. Browsers without clipboard access (or without
  // JS, when this element is never defined) don't show the button.
  class CopyLink2cv extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.status = this.querySelector('[data-copy-status]');

      if (!navigator.clipboard) {
        this.hidden = true;
        return;
      }

      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.onClick) this.button.removeEventListener('click', this.onClick);
      clearTimeout(this.timer);
    }

    onClick() {
      navigator.clipboard.writeText(this.dataset.url).then(() => {
        this.classList.add('is-copied');
        this.status.textContent = 'Link copied';
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.classList.remove('is-copied');
          this.status.textContent = '';
        }, 2000);
      });
    }
  }

  if (!customElements.get('copy-link-2cv')) {
    customElements.define('copy-link-2cv', CopyLink2cv);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cars-for-sale-2cv"] && !Shopify.designMode) return;
  try {
    
  // Filter chips show only cars whose Category matches (in both the main
  // grid and Recently sold) and keep the "N cars available" count and the
  // empty message in step. Sold cards past the second row are hidden by CSS
  // (only once this element is defined, so they all show without JS) until
  // "Show more" is pressed.
  class CarsForSale2cv extends HTMLElement {
    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('[data-filter]'));
      this.grid = this.querySelector('[data-cars-grid]');
      this.count = this.querySelector('[data-cars-count]');
      this.empty = this.querySelector('[data-cars-empty]');
      this.sold = this.querySelector('[data-cars-sold]');
      this.soldGrid = this.querySelector('[data-cars-sold-grid]');
      this.more = this.querySelector('[data-cars-more]');
      this.filter = '';

      this.onClick = this.onClick.bind(this);
      this.update = this.update.bind(this);
      this.addEventListener('click', this.onClick);
      // The sold grid gains columns at these widths, which changes how many
      // cards fit in two rows.
      this.queries = ['(min-width: 750px)', '(min-width: 990px)'].map((query) => window.matchMedia(query));
      this.queries.forEach((query) => query.addEventListener('change', this.update));

      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.queries.forEach((query) => query.removeEventListener('change', this.update));
    }

    onClick(event) {
      const chip = event.target.closest('[data-filter]');
      if (chip) {
        this.filter = chip.dataset.filter;
        this.chips.forEach((button) => button.setAttribute('aria-pressed', button === chip ? 'true' : 'false'));
        this.update();
      } else if (event.target.closest('[data-cars-more]')) {
        this.soldGrid.classList.add('is-expanded');
        this.update();
      }
    }

    update() {
      const listed = this.showMatching(this.grid);
      const available = listed.filter((card) => card.dataset.status === 'available').length;
      this.count.textContent = `${available} ${available === 1 ? 'car' : 'cars'} available`;

      if (this.grid) this.grid.hidden = listed.length === 0;
      if (this.empty) {
        this.empty.hidden = listed.length > 0;
        this.empty.textContent = this.filter ? this.empty.dataset.emptyFilter : this.empty.dataset.emptyAll;
      }

      if (this.sold) {
        const sold = this.showMatching(this.soldGrid);
        this.sold.hidden = sold.length === 0;
        this.more.hidden = !sold.some((card) => getComputedStyle(card).display === 'none');
      }
    }

    // Hides the grid's cards outside the current filter; returns the rest.
    showMatching(grid) {
      if (!grid) return [];

      const cards = Array.from(grid.querySelectorAll('[data-car-card]'));
      cards.forEach((card) => {
        card.hidden = this.filter !== '' && card.dataset.category !== this.filter;
      });
      return cards.filter((card) => !card.hidden);
    }
  }

  if (!customElements.get('cars-for-sale-2cv')) {
    customElements.define('cars-for-sale-2cv', CarsForSale2cv);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-2cv"] && !Shopify.designMode) return;
  try {
    
  // The contact form: picking a topic shows its hint and extra fields
  // (the others are hidden and disabled, so they aren't sent). With the
  // newsletter box ticked, sending first signs the email up to the
  // newsletter through Shopify's customer form, as the header's sign-up
  // does, then sends the message. The sign-up waits at most 3 seconds and
  // failing it doesn't stop the message; the email we get says
  // "Newsletter: Yes" either way.
  class ContactForm2cv extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);

      // The browser may bring back a different topic on "Back".
      const picked = this.querySelector('[data-topic]:checked');
      if (picked) this.showTopic(picked.dataset.topic);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    }

    onChange(event) {
      if (event.target.matches('[data-topic]')) this.showTopic(event.target.dataset.topic);
    }

    showTopic(topic) {
      this.querySelectorAll('[data-topic-panel]').forEach((panel) => {
        const show = panel.dataset.topicPanel === topic;
        panel.hidden = !show;
        panel.querySelectorAll('input, textarea, select').forEach((field) => {
          field.disabled = !show;
        });
      });
    }

    async onSubmit(event) {
      const newsletter = this.form.querySelector('[data-newsletter]');
      if (!newsletter || !newsletter.checked || this.signedUp) return;

      event.preventDefault();
      this.signedUp = true;

      const signup = new FormData();
      signup.append('form_type', 'customer');
      signup.append('utf8', '✓');
      signup.append('contact[email]', this.form.querySelector('[name="contact[email]"]').value);
      signup.append('contact[tags]', 'newsletter');

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 3000);
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        await fetch(`${root}contact`, { method: 'POST', body: signup, signal: controller.signal });
      } catch (error) {
        // Not signed up; the message still goes, marked "Newsletter: Yes".
      } finally {
        clearTimeout(timer);
      }

      if (this.form.requestSubmit) {
        this.form.requestSubmit();
      } else {
        this.form.submit();
      }
    }
  }

  if (!customElements.get('contact-form-2cv')) {
    customElements.define('contact-form-2cv', ContactForm2cv);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["era-timeline-2cv"] && !Shopify.designMode) return;
  try {
    
  // Shows one era's panel at a time. The era buttons, the year dots and
  // each panel's "Next" button all switch era; in the theme editor,
  // selecting an era or entry block switches to its era too.
  class EraTimeline2cv extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onClick(event) {
      const next = event.target.closest('[data-era-next]');
      if (next) {
        this.show(next.dataset.eraNext);
        this.revealNewEra();
        return;
      }

      const pick = event.target.closest('[data-era-pick]');
      if (pick) this.show(pick.dataset.eraPick);
    }

    onBlockSelect(event) {
      const index = event.target.dataset.eraPick ?? event.target.dataset.era;
      if (index !== undefined) this.show(index);
    }

    show(index) {
      this.querySelectorAll('.era-timeline-2cv__era').forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.eraPick === index);
      });
      this.querySelectorAll('.era-timeline-2cv__dot').forEach((dot) => {
        dot.classList.toggle('is-active', dot.dataset.eraPick === index);
      });
      this.querySelectorAll('[data-era-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.eraPanel !== index;
      });
    }

    // "Next" sits under the entries, so the new era's (often shorter) list
    // can leave the reader looking at the footer. Hand focus to the new
    // panel's heading, and bring the era buttons back into view when
    // they've scrolled up under the sticky nav bar.
    revealNewEra() {
      const heading = this.querySelector('[data-era-panel]:not([hidden]) .era-timeline-2cv__era-title');
      if (heading) heading.focus({ preventScroll: true });

      const eras = this.querySelector('.era-timeline-2cv__eras');
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      if (eras.getBoundingClientRect().top < headerHeight) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        eras.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    }
  }

  if (!customElements.get('era-timeline-2cv')) {
    customElements.define('era-timeline-2cv', EraTimeline2cv);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2cv"]) return;
  try {
    
  // Only the nav bar (and the category bar under it) sticks: the whole
  // section is made sticky (a child can't stick past its own section), then
  // pulled up by the height of the utility bar + banner so they scroll away
  // and the nav bar pins to the top. The banner's height follows its aspect
  // ratio, so re-measure whenever the header resizes.
  class Sticky2cvHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header-2cv');
      this.nav = this.querySelector('.header-2cv__nav');
      if (!this.header || !this.nav) return;

      this.header.classList.add('shopify-section-header-sticky');
      this.setStickyOffset();
      this.resizeObserver = new ResizeObserver(() => this.setStickyOffset());
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    // clientTop is the nav bar's orange top border — included in the
    // offset so it scrolls away with the banner rather than sticking.
    // --header-height is everything that stays pinned: the nav bar and, on
    // desktop, the category bar.
    setStickyOffset() {
      const scrolledAway = this.nav.offsetTop + this.nav.clientTop;
      this.header.style.top = `-${scrolledAway}px`;
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight - scrolledAway}px`);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', Sticky2cvHeader);
  }

  // A button that drops a panel down from the header: the compact search
  // under the nav bar, and the newsletter sign-up under the utility bar.
  // Closes on Escape, on the panel's close button, on a tap on the search
  // panel's backdrop (the panel itself, outside its white box) or anywhere
  // else on the page — including the hamburger or the other panel's
  // button, so no two ever sit open on top of each other.
  class PanelToggle2cv extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button[aria-controls]');
      this.panel = document.getElementById(this.button.getAttribute('aria-controls'));
      this.input = this.panel.querySelector('input:not([type="hidden"])');

      this.onButtonClick = this.onButtonClick.bind(this);
      this.onPanelClick = this.onPanelClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.button.addEventListener('click', this.onButtonClick);
      this.panel.addEventListener('click', this.onPanelClick);
      this.addEventListener('keyup', this.onKeyUp);

      // Shopify posts the newsletter form to /contact#<form id> and comes
      // back to this page with that hash, so reopen the panel to show its
      // thank-you or error message. Keyed on the hash rather than the form
      // state, so the home page's own sign-up form doesn't open it too.
      const form = this.panel.querySelector('form[id]');
      if (form && window.location.hash === `#${form.id}`) this.open();
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.onButtonClick);
      this.panel.removeEventListener('click', this.onPanelClick);
      this.removeEventListener('keyup', this.onKeyUp);
      document.removeEventListener('click', this.onDocumentClick);
    }

    onButtonClick(event) {
      this.panel.hidden ? this.open(event) : this.close();
    }

    onPanelClick(event) {
      if (event.target.closest('[data-panel-close]')) {
        this.close(true);
      } else if (event.target === this.panel) {
        this.close();
      }
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE' || this.panel.hidden) return;
      this.close(true);
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    open(event) {
      // Dawn's drawer only closes when given an element to hand focus to,
      // so pass it the panel's input.
      const drawer = document.querySelector('.header-2cv header-drawer');
      const drawerDetails = drawer && drawer.querySelector('details');
      if (drawerDetails && drawerDetails.hasAttribute('open')) {
        drawer.closeMenuDrawer(event, this.input);
        drawerDetails.querySelector('summary').setAttribute('aria-expanded', false);
      }

      this.panel.hidden = false;
      this.button.setAttribute('aria-expanded', true);
      this.input.focus();
      document.addEventListener('click', this.onDocumentClick);
    }

    close(returnFocus = false) {
      this.panel.hidden = true;
      this.button.setAttribute('aria-expanded', false);
      document.removeEventListener('click', this.onDocumentClick);
      if (returnFocus) this.button.focus();
    }
  }

  if (!customElements.get('search-toggle-2cv')) {
    customElements.define('search-toggle-2cv', class SearchToggle2cv extends PanelToggle2cv {});
  }

  if (!customElements.get('newsletter-toggle-2cv')) {
    customElements.define('newsletter-toggle-2cv', class NewsletterToggle2cv extends PanelToggle2cv {});
  }

  // The category bar's groups (snippets/header-category-bar-2cv.liquid) are
  // <details>, so click, Enter and Space work natively. On top of that: with a
  // mouse, hovering a group opens it (moving along the bar switches panels)
  // and leaving the bar and its panel closes it, and a click never closes a
  // panel the mouse is over. Only one is open at a time, and Escape, a click
  // elsewhere or tabbing out closes it.
  class CategoryBar2cv extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('details'));
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.groups.forEach((details) => {
        const summary = details.querySelector('summary');
        summary.setAttribute('aria-expanded', 'false');
        details.addEventListener('toggle', () => this.onToggle(details));
        details.addEventListener('pointerenter', (event) => this.onPointerEnter(event, details));
        summary.addEventListener('click', (event) => this.onSummaryClick(event, details));
      });
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.schedule(() => this.closeAll(), 250);
      });
      this.addEventListener('keyup', (event) => this.onKeyUp(event));
      this.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) this.closeAll();
        });
      });
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('click', this.onDocumentClick);
    }

    schedule(action, delay) {
      clearTimeout(this.timer);
      this.timer = setTimeout(action, delay);
    }

    openGroup() {
      return this.groups.find((details) => details.open);
    }

    // A short pause before opening, so crossing the bar on the way to the
    // page doesn't flash panels open; none once a panel is already showing.
    onPointerEnter(event, details) {
      if (event.pointerType !== 'mouse') return;
      this.schedule(() => (details.open = true), this.openGroup() ? 0 : 120);
    }

    onSummaryClick(event, details) {
      clearTimeout(this.timer);
      if (event.pointerType === 'mouse' && details.open) event.preventDefault();
    }

    onToggle(details) {
      details.querySelector('summary').setAttribute('aria-expanded', details.open);
      if (details.open) {
        this.groups.forEach((other) => {
          if (other !== details) other.open = false;
        });
        document.addEventListener('click', this.onDocumentClick);
      } else if (!this.openGroup()) {
        document.removeEventListener('click', this.onDocumentClick);
      }
    }

    onKeyUp(event) {
      const details = this.openGroup();
      if (event.code.toUpperCase() !== 'ESCAPE' || !details) return;
      details.open = false;
      details.querySelector('summary').focus();
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.closeAll();
    }

    closeAll() {
      clearTimeout(this.timer);
      this.groups.forEach((details) => (details.open = false));
    }
  }

  if (!customElements.get('category-bar-2cv')) {
    customElements.define('category-bar-2cv', CategoryBar2cv);
  }

  // The same menu in the mobile drawer, as an accordion of <details>. Dawn's
  // drawer script (assets/global.js, MenuDrawer) listens to every <summary>
  // in the drawer and would slide these off as submenus, so their clicks are
  // stopped here, on the way down, before they reach it. The details still
  // open and close on their own.
  class CategoryAccordion2cv extends HTMLElement {
    connectedCallback() {
      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('summary')) event.stopPropagation();
        },
        { capture: true }
      );
    }
  }

  if (!customElements.get('category-accordion-2cv')) {
    customElements.define('category-accordion-2cv', CategoryAccordion2cv);
  }

  // Search as you type: Dawn's predictive search (assets/predictive-search.js)
  // for the header's search boxes (snippets/header-search-form-2cv.liquid).
  // Dawn's script loads after this one, so wait for it; with predictive
  // search off in Theme settings it never loads and the boxes stay plain
  // search forms.
  customElements.whenDefined('predictive-search').then(() => {
    class PredictiveSearch2cv extends customElements.get('predictive-search') {
      constructor() {
        super();
        // Dawn shares cached results between its <predictive-search>
        // elements; share them between the header's two boxes instead.
        this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search-2cv');
      }

      // Escape closes the results (Dawn leaves that to its search modal).
      // Stopping it there means a second Escape closes the compact panel.
      // Dawn only opens a highlighted suggestion on the main Enter key; the
      // numpad's would do nothing (the form's submit is blocked while one is
      // highlighted), so it gets the same treatment.
      onKeyup(event) {
        if (event.code === 'Escape' && this.isOpen) {
          event.stopPropagation();
          this.close();
          return;
        }
        if (event.code === 'NumpadEnter') {
          this.selectOption();
          return;
        }
        super.onKeyup(event);
      }

      // Dawn sizes the results to reach the bottom of the screen from the
      // bottom of the header, but these hang below the search box — in the
      // compact panel, well below the nav bar — so measure from the box
      // instead, and to the bottom of the visible viewport so a phone's
      // keyboard doesn't cover the last rows.
      getResultsMaxHeight() {
        const viewport = window.visualViewport;
        const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        const boxBottom = this.input.form.getBoundingClientRect().bottom;
        this.resultsMaxHeight = Math.max(viewportBottom - boxBottom - 24, 160);
        return this.resultsMaxHeight;
      }
    }

    if (!customElements.get('predictive-search-2cv')) {
      customElements.define('predictive-search-2cv', PredictiveSearch2cv);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rebuild-options-2cv"] && !Shopify.designMode) return;
  try {
    
  // Shows the details and steps panels for the checked option. In the
  // theme editor, selecting an option or step block switches to it too.
  class RebuildOptions2cv extends HTMLElement {
    connectedCallback() {
      this.onChange = this.onChange.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.addEventListener('change', this.onChange);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onChange(event) {
      if (event.target.classList.contains('rebuild-options-2cv__radio')) this.show(event.target.value);
    }

    onBlockSelect(event) {
      const owner = event.target.closest('[data-rebuild-option], [data-rebuild-panel]');
      if (!owner) return;

      const optionId = owner.dataset.rebuildOption || owner.dataset.rebuildPanel;
      const radio = this.querySelector(`.rebuild-options-2cv__radio[value="${optionId}"]`);
      if (radio) radio.checked = true;
      this.show(optionId);
    }

    show(optionId) {
      this.querySelectorAll('[data-rebuild-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.rebuildPanel !== optionId;
      });
    }
  }

  if (!customElements.get('rebuild-options-2cv')) {
    customElements.define('rebuild-options-2cv', RebuildOptions2cv);
  }

  } catch(e) { console.error(e); }
})();
})();
